namespace Solovis.Reports.Parameters {

    /**
     * ExplicitParameterControl only allows parameter to be set programmatically and has no UI for editing. Usually set to hidden.
     */
    export class ExplicitParameterControl extends Solovis.UI.BaseControl {

        public currentValue;

        constructor(options) {
            super(options);

            this.currentValue = (typeof options.initialValue != "undefined") ? options.initialValue : false;
        }

        public doInit() {
        }

        public doRender() {            
        }

        public setParameterValue(newValue) {
            this.currentValue = newValue;
        }

        public getParameterValue() {
            return this.currentValue;
        }

        public notifyParameterValueChanged() {
            $(this).trigger("parameterValueChanged");
        }
    }

}